module.exports = __webpack_public_path__ + "img/Pause.319b3df8.svg";